import { PassengerType, Traveler } from '@/src/types/itinerary'

interface LocalTravelerData {
    itineraryId: string
    travelers: Traveler[]
    travelersIndexToPassengerTypeAndSerialNumberMap: Record<
        number,
        { type: PassengerType; count: number; typeString: string }
    >
    // contactDetails: Customer
    // taxDetails: TaxDetails
}
const key = 'itin-pre-filled-travelers'

export const clearLocalSavedTravelerData = (id: string) => {
    const localTravelerData = localStorage.getItem(key)
    if (localTravelerData) {
        const localTravelerDataJson: {
            itineraryId: string
        } = JSON.parse(localTravelerData)
        if (id?.startsWith(localTravelerDataJson.itineraryId)) {
            localStorage.removeItem(key)
        }
    }
}

export const saveTravelerDataLocal = (data: LocalTravelerData) => {
    //localStorage.setItem(key, JSON.stringify(data))
}

export const getLocalSavedTravelerData = (): LocalTravelerData | null => {
    // const localTravelerData = localStorage.getItem(key)
    // return localTravelerData ? JSON.parse(localTravelerData) : null
    return null;
}
